module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_historical_number_usage-b9614d1634a0aebf7ded77a97d29da5c.png";